export default function rem(value) {
	if (typeof value === 'string') {
		if (value.trim().endsWith('%')) return value;

		value = Number(value);
	}

	return `${value / 16}rem`;
}
